/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

import 'core-js/es/array/at';
import 'core-js/es/object/has-own';

/* Polyfill for element.closest */
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s: string): Element | null {
    let el: Element | null = this;

    do {
      if (el.matches(s)) {
        return el;
      }
      el = el.parentElement;
    } while (el);

    return null;
  };
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
